import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=1fdb619e"
import script from "./AppLayout.vue?vue&type=script&lang=ts"
export * from "./AppLayout.vue?vue&type=script&lang=ts"
import style0 from "./AppLayout.vue?vue&type=style&index=0&id=1fdb619e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mortgage-front/mortgage-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fdb619e')) {
      api.createRecord('1fdb619e', component.options)
    } else {
      api.reload('1fdb619e', component.options)
    }
    module.hot.accept("./AppLayout.vue?vue&type=template&id=1fdb619e", function () {
      api.rerender('1fdb619e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/core/components/AppLayout.vue"
export default component.exports